import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import api from '../api/axios';
import Intro from '../components/home/Intro';
import IntroFeria from '../components/home/IntroFeria';

export default function Home() {
  const [servicios, setServicios] = useState([]);

  useEffect(() => {
    api.get('/servicios')
      .then(res => setServicios(res.data.servicios))
      .catch(err => console.error('❌ Error al cargar servicios:', err));
  }, []);

  return (
    <main className="home">
      <IntroFeria/>
      <div className="bg-barber"></div>

      <div className="bg-seccion">
      <section className="site-width seccion-servicio">
        <h2>Servicios</h2>
        <div className="grid-servicios">
          {servicios.map(serv => (
            <div className="servicio-item" key={serv.id}>
              <h3>{serv.nombre}</h3>
              <div className='tiempo-servicio'>
                <img src="/images/tiempo.svg" alt="Icono"/>
                <p>{serv.duracion} minutos</p>
              </div>
              <div className="servicio-bottom">
                <p>{serv.precio}<span className='currency-item-servicio'>€</span></p> 
                <Link to={`/reservar?id=${serv.id}`}>Reserva ahora</Link>
              </div>
            </div>
          ))}
        </div>
      </section>
      </div>
    </main>
  );
}
